import { ReactMFE, Providers } from "@tpd-web-common-libs/nodejs-library";
import React from "react";
import { editorSelector } from "../../store/slices/editor.slice";


interface HookDeps {
  useSelector: (selector: any) => any; // Use proper types from your Redux setup if possible
}

export const commonHook = ({ useSelector }: HookDeps, isClientRendering: boolean) => {
  const importMFEBy = isClientRendering
    ? (__mfeName__: string) =>
        Providers.RemoteService.getInstance().dynamicImportClientSideMFE(
          __mfeName__
        )
    : (__mfeName__: string) =>
        Providers.RemoteService.getInstance().dynamicImportServerSideMFE(
          __mfeName__
        );

  return (props: Record<string, any>): ReactMFE.Types.TRemoteReactMFEProps => {
    const { isEditMode, touchpoint } = useSelector(editorSelector);

    return {
      ...(props as any),
      __host__: {
        ...(props.__host__ || {}),
        router: Providers.RouterService.getInstance().router,
        importMFEBy,
        isClientRendering,
      },
      __deps__: React,
      isEditMode,
      touchpoint,
    };
  };
};
